import { all } from 'redux-saga/effects';

function* App() {
  yield all([]);
}

export default App;
